import { all, fork } from 'redux-saga/effects';
import init from './init';
import layout from './layout';
import modules from './modules';
export default function* rootSaga() {
    yield all([
        fork(init),
        fork(layout),
        fork(modules)
    ]);
}

//# sourceMappingURL=index.js.map